import { BankratePropertyUse } from '@bankrate/mortgage-types'
import { computed, Computed } from 'easy-peasy'
import { defaultEmailFormConfig, emailFormConfigService, EmailFormConfig } from 'utils/emailFormConfigService'

export interface EmailCaptureModel {
  emailFormConfig: Computed<EmailCaptureModel, EmailFormConfig>
}

const emailCapture: EmailCaptureModel = {
  emailFormConfig: computed(
    [
      state => state,
      // @ts-ignore
      (state, storeState) => storeState.dimensions.dimensions,
    ],
    (state, dimensions) => {
      if (!dimensions.user || !dimensions.refinance || !dimensions.purchase) {
        return defaultEmailFormConfig
      }

      let isCashout = false

      // Allow null here so that we don't accidentaly match some default when we don't mean to
      let propertyUse: BankratePropertyUse | null = null

      if (dimensions.mortgageType === 'Refinance') {
        isCashout = dimensions.refinance.cashOutAmount > 0
        propertyUse = dimensions.refinance.propertyUse
      }

      if (dimensions.mortgageType === 'Purchase') {
        propertyUse = dimensions.purchase.propertyUse
      }

      // Ok to use a customers local time
      const businessHoursStart = new Date()
      const businessHoursEnd = new Date()
      const currentTime = Date.now()

      businessHoursStart.setHours(9, 0, 0, 0) // 9am
      businessHoursEnd.setHours(12 + 5, 0, 0, 0) // 5pm

      const withinBusinessHours =
        currentTime >= businessHoursStart.getTime() && currentTime <= businessHoursEnd.getTime()

      const criteria: EmailFormConfig['criteria'] = {
        isWeekday: [1, 2, 3, 4, 5].includes(new Date().getDay()),
        withinBusinessHours, // TOOD: fill this out, use moment timezone?
        loanType: dimensions.mortgageType,
        isCashout,
        isVA: dimensions.user.veteranStatus !== 'NoMilitaryService',
        isFHA: dimensions.user.fha,
        propertyUse,
      }

      return emailFormConfigService.findEmailFormConfig(criteria)
    }
  ),
}

export default emailCapture
